






















































































import { ITopic } from "@/models/Topic.model";
import { Component, Vue } from "vue-property-decorator";
import LoadingOverlay from "@/components/shared/LoadingOverlay.vue";

@Component({ components: { LoadingOverlay } })
export default class Topics extends Vue {
  get topics() {
    return this.$store.getters.getTopics;
  }

  index = 0;

  next() {
    this.index++;
  }

  previous() {
    if (this.index == 0) this.index = this.topics.length;
    this.index--;
  }

  displayModal = false;
  topic: ITopic = {};

  displayTopic(topic: ITopic) {
    this.topic = topic;
    this.displayModal = true;
  }

  closeTopic() {
    this.displayModal = false;
  }
}
